import Commander from "./Commander";
import {STATES} from "../framework/src/states/states";
import {CONFIG_PARAMS} from "../framework/src/system/SystemConfig";

export default class States  {

    constructor(commander) {

        this.commander = commander;
    }


    move(reel, shift){
    }
    
    accUp(data) {
        let reel = data.reel;
        if (this.inRespin) {
            let stops = 5*this.config.get(CONFIG_PARAMS.BEHAVIOR).reel.spin.delayBetweenReelStops;
            let starts = this.config.get(CONFIG_PARAMS.BEHAVIOR).reel.spin.delayBetweenReelStarts;
            let tmp = stops*reel.getId() - starts*(1+reel.getId());
            this.slots.reels.setSymbolsToStoppingDelay(reel.getId(), tmp);
        }
    }

    accDown(data) {
        let reel = data.reel;
        for (let symbol of reel.getSpinSymbols()) {
            symbol.alpha = (reel.data.wild === true) ? 0 : 1;
        }
    }

    spin(data) {
        let reel = data.reel;
        for (let symbol of reel.getResSymbols()) {
            symbol.blur();
            symbol.alpha = (reel.data.wild === true) ? 0 : 1;


        }
        for (let symbol of reel.getSpinSymbols()) {
            symbol.blur();
            symbol.visible = true;
            symbol.alpha = (reel.data.wild === true) ? 0 : 1;
        }
    }

    stopping(data) {
        let reel = data.reel;
        if (reel.getId() === 4 && !this.inRespin && !this.game.isAutoRun()) {
            this.states.setState(STATES.FORCESPIN);
        }
    }

    brakeDown(data) {
        let reel = data.reel;
        if (reel.data.wild === false) {
            if (data.isForceStopping()) {
                if (!reel.getId()) {
                    this.audio.playTrack("reel_Stop");
                }
            } else {
                this.audio.playTrack("reel_Stop");
            }
        }
        let i = 0;
        for (let symbol of reel.getResSymbols()) {
            symbol.unblur();
            if (symbol.symbolName === "symbol_crystal_wild" && reel.data.wild === false)
                this.audio.playTrack("bonus_Wild");
        }
        for (let symbol of reel.getSpinSymbols()) {
            symbol.unblur();
        }
        if (reel.getId() === 4 && this.audio.isPlaying("reel_Start_Wild")) {
            // @ts-ignore
            this.audio.fadeOutTrack("reel_Start_Wild", 500);
        }
    }

    brakeUp(reel) {
    }


    stop(data) {
        let reel = data.reel;
        for (let symbol of reel.getResSymbols()) {
            if (symbol.symbolIndex === 7 && !reel.data.wild) {
                symbol.visible = false;
                let newSymbol = this.WildWin.getSymbol(symbol.name);
                newSymbol.position.set(symbol.x, symbol.y);
                this.WildWin.layer.anim.addChild(newSymbol);
                this.WildWin.wildParticles(symbol);
                newSymbol.spinSpiral();
            }
        }
    }
}
